import { render, staticRenderFns } from "./FieldValue.vue?vue&type=template&id=3df648f7&scoped=true&"
import script from "./FieldValue.vue?vue&type=script&lang=js&"
export * from "./FieldValue.vue?vue&type=script&lang=js&"
import style0 from "./FieldValue.vue?vue&type=style&index=0&id=3df648f7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df648f7",
  null
  
)

export default component.exports